export const formHeaderTH = {
    header: "เปิดรับสมัครวันที่"
}

export const formHeaderEN = {
    header: "Open for application"
}

